import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import FormInputText from "../../../components/FormInputText";
import { toast } from "react-toastify";
import Upload from "../../../components/uploadFile.js";
import { useDispatch, useSelector } from "react-redux";
import { categoryList } from "./categorySlice";
import { addSubCategory } from "./subCategorySlice";

const AddSubCategory = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [image, setImage] = useState({
    imagePreview: "",
    image: "",
    rank: "",
  });

  useEffect(() => {
    dispatch(categoryList({ page: "1", limit: "1000", search: "" }));
  }, [dispatch]);

  const data = useSelector((state) => state.category.categoryList.data);
  console.log(data, "data");

  const validationSchema = Yup.object().shape({
    sub_category: Yup.string().required("*Sub Category Name is Required"),
    category: Yup.string().required("*Category Name is Required"),
    rank: Yup.number()
      .positive("Kindly enter a positive number")
      ?.integer("Kindly enter a valid number")
      ?.required("*Rank is Required"),
  });

  const { values, handleSubmit, touched, errors, handleChange } = useFormik({
    initialValues: {
      sub_category: "",
      category: "",
      rank: "",
    },
    validationSchema,
    onSubmit: async ({ category, sub_category, rank }) => {
      if (image && image.image) {
        let formdata = new FormData();
        formdata.append("image", image.image);
        formdata.append("category", category);
        formdata.append("rank", rank);
        formdata.append("sub_category", sub_category);
        dispatch(addSubCategory(formdata, { dispatch })).then((data) => {
          if (data?.payload?.response_code === 200) {
            history.push("/admin/sub-category");
            toast.success("Success");
          } else {
            toast.error(data?.payload?.message);
          }
        });
      } else {
        toast.error("* Please add image.");
      }
    },
  });

  const dataHandler = (data) => {
    setImage({
      ...image,
      image: data.location,
    });
  };

  return (
    <article class="col-lg-9">
      <div class="article-body store-bd-gy">
        <div class="row align-items-center col-rever">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <h2 class="head-title">Add New Sub-Category</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <form onSubmit={handleSubmit} class="form-style">
              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12 text-center">
                  <Upload dataHandler={dataHandler} />
                </div>
                <div class="col-sm-6 col-md-6 col-lg-6">
                  <FormInputText
                    placeholder="Enter Sub-Category Name"
                    type="text"
                    image="small-cate.png"
                    onChange={handleChange}
                    name="sub_category"
                    value={values.sub_category}
                    title="Sub-Category Name"
                  />

                  <span className="errorMessage">
                    {touched["sub_category"] && errors["sub_category"]}
                  </span>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>Category</label>
                    <div class="input-container">
                      <select
                        onChange={handleChange}
                        name="category"
                        value={values.category}
                        class="form-control pl-5"
                      >
                        <option value="">Select Category</option>
                        {data &&
                          data.map((data) => {
                            return <option value={data.id}>{data.name}</option>;
                          })}
                      </select>
                      <img
                        src="assets/images/small-cate.png"
                        class="input-img"
                        alt=""
                      />
                    </div>
                  </div>
                  <span className="errorMessage">
                    {touched["category"] && errors["category"]}
                  </span>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-6">
                  <FormInputText
                    placeholder="Rank"
                    image="small-cate.png"
                    onChange={handleChange}
                    name="rank"
                    type="number"
                    value={values.rank}
                    title="Rank"
                  />

                  <span className="errorMessage">
                    {touched["rank"] && errors["rank"]}
                  </span>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-12 mt-5">
                  <div class="text-center">
                    <button type="submit" class="btn btn-save">
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </article>
  );
};

export default AddSubCategory;
